import React, { Component } from 'react'
import { Alert, Button, Card, Col, Row, Select, Table, Tag, Typography } from 'antd'
import { getFrequencyMonitorOverview } from '../../request'
import './index.less'

const { Text, Title } = Typography
const { Option } = Select

const clientTypeColorMap = {
    callerKey: 'blue',
    internalApp: 'purple',
    miniappToken: 'gold',
    dingId: 'cyan',
    secureLcAuth: 'orange',
    ip: 'green',
    unknown: 'default'
}

const formatDateTime = (value) => {
    if (!value) {
        return '-'
    }
    const date = new Date(value)
    const pad = (num) => `${num}`.padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

class FrequencyMonitor extends Component {
    state = {
        loading: false,
        limit: 50,
        overview: null
    }

    componentDidMount() {
        this.loadData()
        this.timer = window.setInterval(this.loadData, 10000)
    }

    componentWillUnmount() {
        if (this.timer) {
            window.clearInterval(this.timer)
        }
    }

    loadData = async () => {
        const { limit } = this.state
        this.setState({ loading: true })
        try {
            const overview = await getFrequencyMonitorOverview({ limit })
            this.setState({ overview })
        } finally {
            this.setState({ loading: false })
        }
    }

    onLimitChange = (limit) => {
        this.setState({ limit }, this.loadData)
    }

    getHotColumns = () => ([
        {
            title: '次数',
            dataIndex: 'count',
            width: 90,
            render: (value) => <Text strong type={value > 0 ? 'danger' : undefined}>{value}</Text>
        },
        {
            title: '方法',
            dataIndex: 'method',
            width: 90
        },
        {
            title: '接口',
            dataIndex: 'path',
            ellipsis: true
        },
        {
            title: '来源类型',
            dataIndex: 'clientType',
            width: 120,
            render: (value) => <Tag color={clientTypeColorMap[value] || 'default'}>{value || '-'}</Tag>
        },
        {
            title: '来源标识',
            dataIndex: 'clientKey',
            width: 160,
            ellipsis: true
        }
    ])

    getAlertColumns = () => ([
        {
            title: '时间',
            dataIndex: 'timestamp',
            width: 170,
            render: (value) => formatDateTime(value)
        },
        {
            title: '窗口',
            dataIndex: 'windowSeconds',
            width: 90,
            render: (value) => `${value}s`
        },
        {
            title: '阈值',
            dataIndex: 'threshold',
            width: 90
        },
        {
            title: '次数',
            dataIndex: 'count',
            width: 90,
            render: (value) => <Text strong type={'danger'}>{value}</Text>
        },
        {
            title: '方法',
            dataIndex: 'method',
            width: 90
        },
        {
            title: '接口',
            dataIndex: 'path',
            ellipsis: true
        },
        {
            title: '来源类型',
            dataIndex: 'clientType',
            width: 120,
            render: (value) => <Tag color={clientTypeColorMap[value] || 'default'}>{value || '-'}</Tag>
        },
        {
            title: '来源标识',
            dataIndex: 'clientKey',
            width: 160,
            ellipsis: true
        }
    ])

    renderWindowCard = (windowSeconds) => {
        const { overview, loading } = this.state
        const key = `${windowSeconds}s`
        const hotEntries = overview && overview.hotEntries ? overview.hotEntries[key] || [] : []
        const thresholds = overview && overview.thresholds ? overview.thresholds : {}
        return (
            <Col span={8} key={key}>
                <Card
                    size={'small'}
                    title={`${key} 热点接口`}
                    extra={<Text type={'secondary'}>阈值 {thresholds[key] || '-'}</Text>}
                >
                    <Table
                        rowKey={(record, index) => `${record.method}-${record.path}-${record.clientType}-${record.clientKey}-${index}`}
                        size={'small'}
                        pagination={false}
                        loading={loading}
                        dataSource={hotEntries}
                        columns={this.getHotColumns()}
                        scroll={{ x: 720, y: 420 }}
                    />
                </Card>
            </Col>
        )
    }

    render() {
        const { loading, limit, overview } = this.state
        const windows = overview && overview.windows ? overview.windows : [10, 60, 300]
        const alerts = overview && overview.alerts ? overview.alerts : []
        return (
            <div className={'frequency-monitor-page'}>
                <Card
                    className={'frequency-monitor-card'}
                    title={<Title level={4}>网关接口频率监测</Title>}
                    extra={
                        <div className={'frequency-monitor-toolbar'}>
                            <Text type={'secondary'}>更新时间 {formatDateTime(overview && overview.serverTime)}</Text>
                            <Select value={limit} style={{ width: 100 }} onChange={this.onLimitChange}>
                                <Option value={20}>20 条</Option>
                                <Option value={50}>50 条</Option>
                                <Option value={100}>100 条</Option>
                            </Select>
                            <Button onClick={this.loadData} loading={loading}>刷新</Button>
                        </div>
                    }
                >
                    <Alert
                        className={'frequency-monitor-alert'}
                        type={'info'}
                        showIcon={true}
                        message={'当前只做监测和告警，不做拦截。数据按 10 秒、60 秒、300 秒窗口聚合。'}
                    />
                    <Row gutter={[16, 16]} className={'frequency-monitor-hot'}>
                        {windows.map(this.renderWindowCard)}
                    </Row>
                    <Card size={'small'} title={'最近告警'} className={'frequency-monitor-list'}>
                        <Table
                            rowKey={(record, index) => `${record.timestamp}-${record.path}-${index}`}
                            size={'small'}
                            pagination={false}
                            loading={loading}
                            dataSource={alerts}
                            columns={this.getAlertColumns()}
                            scroll={{ x: 1200, y: 480 }}
                        />
                    </Card>
                </Card>
            </div>
        )
    }
}

export default FrequencyMonitor
